(function () {
  function disableStickyHeaderHide() {
    var stickyHeader = document.querySelector('sticky-header');
    if (!stickyHeader || typeof stickyHeader.disconnectedCallback !== 'function') return;
    stickyHeader.disconnectedCallback();
  }

  function measureTopBar() {
    var ticker = document.querySelector('.home-ticker-section');
    if (ticker && ticker.offsetHeight) {
      return ticker.offsetHeight;
    }

    return 0;
  }

  function syncTopOffset() {
    var top = measureTopBar();
    document.documentElement.style.setProperty('--be-header-top', top + 'px');
    document.documentElement.style.setProperty('--be-announcement-height', top + 'px');
    document.documentElement.style.setProperty('--home-ticker-height', top + 'px');
  }

  function syncHeaderHeight() {
    var wrapper = document.querySelector('.section-header .header-wrapper, sticky-header.header-wrapper');
    if (!wrapper) return;
    document.documentElement.style.setProperty('--be-header-height', wrapper.offsetHeight + 'px');
  }

  function syncHeaderState() {
    var cinemaHero = document.querySelector('[data-home-cinema]');
    var coffeeStage = document.querySelector('[data-coffee-stage]');
    var clear = false;

    if (cinemaHero) {
      clear = window.scrollY <= Math.max(cinemaHero.offsetHeight * 0.55, 120);
    } else if (coffeeStage) {
      clear = coffeeStage.getBoundingClientRect().top > -32;
    }

    document.body.classList.toggle('be-header-clear', clear);
  }

  function syncAll() {
    syncTopOffset();
    syncHeaderHeight();
    syncHeaderState();
  }

  function init() {
    disableStickyHeaderHide();
    syncAll();
    window.addEventListener('scroll', syncHeaderState, { passive: true });
    window.addEventListener('resize', syncAll, { passive: true });
  }

  syncTopOffset();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
